export default __webpack_public_path__ + "components/weather-icon/static/daythunderstorm@3-9f71e3b2fd5fc26c545257126617650d.png";